// extracted by mini-css-extract-plugin
export default {"container":"Invitation_container__Or6kj","ico-post":"Invitation_ico-post__699uX"};